module.exports = __webpack_public_path__ + "img/2.ce63c7f8.jpg";